export default {"src":"/_next/static/media/Arrow Up.6d53525c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};